// extracted by mini-css-extract-plugin
export default {"check":"BuwMpvSmDO9FdeKzOBUZ","highlight":"oGvetyVyzPZ_9GdulLDN","color-warn":"gfw8XK1HbSpMpk6aSylN"};